const moment = require('moment-timezone');

var REQUEST_TYPE = require('../type-ids.js');
var RequestConstants = require('./constants.js');

var Request = (function () {
  function Request(typeName) {
    this.typeId = REQUEST_TYPE[typeName];
    this.typeName = typeName;

    if (this.typeId == null) {
      throw "Cannot find request id. Check request name.";
    }
  }

  return Request;
})();

// global constants
window.SECOND = 0;
window.MINUTE = 1;
window.HOUR = 2;
window.DAY = 3;
window.WEEK = 4;
window.MONTH = 5;
window.YEAR = 6;
window.MILLISECOND = 7;
window.DAY_OF_WEEK = 8;

window.AVERAGE = 0;
window.MIN = 1;
window.MAX = 2;
window.LAST = 3;
window.MEDIAN = 4;
window.COUNT = 5;
window.SUM = 6;
window.CONTINUES_LAST = 7;

window.TRUE = true;
window.FALSE = false;

window.EQUAL = 0;
window.LIKE = 1;
window.LARGER_THAN = 2;
window.LARGER_THAN_OR_EQUAL = 3;
window.LESS_THAN = 4;
window.LESS_THAN_OR_EQUAL = 5;
window.FITS_REGEX = 6;
window.NONE = 7;

var RequestFactory = (function () {
  function RequestFactory() {
  }

  RequestFactory.LoginRequest = function (userId, password) {
    var request = new Request("LoginRequest");
    request.userId = userId;
    if (password) {
      request.password = password;
    }
    return request;
  };

  RequestFactory.LogoutRequest = function () {
    var request = new Request("LogoutRequest");
    return request;
  };

  //========== DASHBOARD ==========

  RequestFactory.UpdateDashboardRequest = function (previousPersistedData, currentPersistedData, userpersistenceId) {
    var request = new Request("UpdateUIDashboard");
    request.previousPersistedData = {
      persistenceId: previousPersistedData.persistenceId,
      tabPosition: previousPersistedData.tabPosition,
      title: previousPersistedData.title,
      variables: JSON.stringify(previousPersistedData.variables),
      user: userpersistenceId,
      originalDashboard: previousPersistedData.originalDashboard,
      originalDashboardUpdateTime: previousPersistedData.originalDashboardUpdateTime
    };

    request.currentPersistedData = {
      persistenceId: currentPersistedData.persistenceId,
      tabPosition: currentPersistedData.tabPosition,
      title: currentPersistedData.title,
      variables: JSON.stringify(currentPersistedData.variables),
      user: userpersistenceId,
      originalDashboard: currentPersistedData.originalDashboard,
      originalDashboardUpdateTime: currentPersistedData.originalDashboardUpdateTime
    };

    return request;
  };

  RequestFactory.CreateDashboardRequest = function (tabPosition,
                                                    title,
                                                    userPersistenceId,
                                                    variables = "{}",
                                                    originalDashboard = null,
                                                    originalDashboardUpdateTime = null) {
    var request = new Request("CreateUIDashboard");
    request.currentPersistedData = {
      tabPosition: tabPosition,
      title: title,
      user: userPersistenceId,
      variables,
      originalDashboard: originalDashboard,
      originalDashboardUpdateTime: originalDashboardUpdateTime
    };
    return request;
  };

  RequestFactory.RemoveDashboardRequest = function (persistenceId) {
    var request = new Request("RemoveUIDashboard");
    request.currentPersistedData = {
      persistenceId: persistenceId
    };
    return request;
  };

  RequestFactory.RemoveUIDashboardStateRequest = function (dashboardId, stateId) {
    var request = new Request("RemoveUIDashboardState");
    request.currentPersistedData = {
      persistenceId: stateId,
      dashboard: dashboardId
    };
    return request;
  };

  RequestFactory.GetDashboardsRequest = function (persistenceId) {
    var request = new Request("GetDashboards");
    request["userUUID"] = persistenceId;
    return request;
  };

  RequestFactory.GetDashboardByIdRequest = function (persistenceId) {
    var request = new Request("GetDashboardById");
    request["uuid"] = persistenceId;
    return request;
  };

  RequestFactory.UpdateDashboardStateRequest = function (previousPersistedData, currentPersistedData) {
    var request = new Request("UpdateUIDashboardState");

    request.previousPersistedData = {
      dashboard: previousPersistedData.dashboard,
      dashboardState: previousPersistedData.dashboardState,
      persistenceId: previousPersistedData.persistenceId
    };

    request.currentPersistedData = {
      dashboard: currentPersistedData.dashboard,
      dashboardState: currentPersistedData.dashboardState,
      persistenceId: currentPersistedData.persistenceId
    };

    return request;
  };

  RequestFactory.CreateDashboardStateRequest = function (dashboardId, state) {
    var request = new Request("CreateUIDashboardState");
    request.currentPersistedData = {
      dashboard: dashboardId,
      dashboardState: state
    };
    return request;
  };

  RequestFactory.GetDashboardStateByIdRequest = function (dashboardId) {
    var request = new Request("GetDashboardStateById");

    request.dashboardId = dashboardId;
    return request;
  };


  //========== DASHBOARD END ==========


  //========== USER ==========

  RequestFactory.UpdateUserRequest = function (previousUser, currentUser) {
    var request = new Request("UpdateUser");
    request.previousPersistedData = previousUser;
    request.currentPersistedData = currentUser
    request.currentPersistedData.verified = true;
    return request;
  };

  RequestFactory.CreateUserRequest = function (userId, firstName, lastName, email) {
    var request = new Request("CreateUser");
    request.userId = userId;
    request.firstName = firstName;
    request.lastName = lastName;
    request.email = email;
    return request;
  };

  RequestFactory.CreateUserCredentialRequest = function (userId, password) {
    var request = new Request("CreateUserCredential");
    request.user = userId;
    request.password = password;
    return request;
  };

  RequestFactory.UpdateUserCredentialRequest = function (oldPassword, newPassword, userId) {
    var request = new Request("PasswordCheckChangeRequest");
    request.UserId = userId;
    request.oldPassword = oldPassword;
    request.newPassword = newPassword;
    return request;
  };

  RequestFactory.RegisterUserRequest = function (userId, password, firstName, lastName, email) {
    var request = new Request("RegisterUserRequest");
    request.userId = userId;
    request.password = password;
    request.firstName = firstName;
    request.lastName = lastName;
    request.email = email || "";
    request.imageUrl = "none";
    return request;
  };

  RequestFactory.SearchUserByUserIdRequest = function (userId) {
    var request = new Request("SearchUserByUserIdRequest");
    request.userId = userId;
    return request;
  };

  RequestFactory.GetCurrentUserRequest = function () {
    return new Request("GetCurrentUserRequest");
  };

  //========== DATASET ==========
  RequestFactory.CreateDataset = function (dataset) {
    var request = new Request("CreateDatasetRequest");
    // request.dataset = dataset;
    Object.assign(request, dataset);
    return request;
  };

  RequestFactory.CreateDataProfile = function (dataProfile) {
    var request = new Request("CreateDataProfile");
    request.currentPersistedData = dataProfile;
    return request;
  };

  RequestFactory.CreateDatasetLicense = function (datasetLicense) {
    var request = new Request("CreateDatasetLicense");
    request.currentPersistedData = datasetLicense;
    return request;
  };

  RequestFactory.GetDataSetsByNameRequest = function (searchString, pageNumber, pageSize) {
    var request = new Request("FindByNameOrDescription");
    request.text = searchString;
    request.pageNumber = pageNumber;
    request.pageSize = pageSize;
    return request;
  };

  RequestFactory.GetDataBankDatasetByNameOrDescriptionForUserOrOrg = function (searchString, organization, user, pageNumber, pageSize) {
    var request = new Request("FindDataBankDatasetByNameOrDescriptionForUserOrOrgRequest");
    request.text = searchString;
    request.pageNumber = pageNumber;
    request.pageSize = pageSize;
    request.organization = organization;
    request.user = user;
    return request;
  };

  RequestFactory.GetDataBankDatasetByNameOrDescription = function (searchString, user, pageNumber, pageSize) {
    var request = new Request("FindDataBankDatasetByNameOrDescriptionForUserRequest");
    request.text = searchString;
    request.pageNumber = pageNumber;
    request.pageSize = pageSize;
    request.user = user;
    return request;
  };

  RequestFactory.GetDataSetByIdRequest = function (dataSetId) {
    var request = new Request("GetDatasetById");
    request.datasetId = dataSetId;
    return request;
  };

  RequestFactory.GetDatasetByIdWithUsersCreated = function (dataSetId, user) {
    var request = new Request("GetDatasetByIdWithUsersCreatedRequest");
    request.datasetId = dataSetId;
    request.user = user;
    return request;
  };

  RequestFactory.GetDataProfileRequest = function (dataProfileId) {
    var request = new Request("GetDataProfileById");
    request.dataProfileId = dataProfileId;
    return request;
  };

  RequestFactory.GetAllDataProfilesRequest = function () {
    var request = new Request("GetAllDataProfilesRequest");
    return request;
  };

  RequestFactory.FindByNameOrDescriptionSubscribedByUserRequest = function (userId, searchString, pageNumber, pageSize) {
    var request = new Request("FindByNameOrDescriptionSubscribedByUserRequest");
    request.user = userId;
    request.text = searchString;
    request.pageNumber = pageNumber;
    request.pageSize = pageSize;
    return request;
  };

  RequestFactory.FindByNameOrDescriptionUnsubscribedByUserRequest = function (userId, organization, searchString, pageNumber, pageSize) {
    if (organization != null) {
      var request = new Request("FindByNameOrDescriptionUnsubscribedByUserOrOrgRequest");
      request.organization = organization;
    }
    else {
      var request = new Request("FindByNameOrDescriptionUnsubscribedByUserRequest");
    }
    request.user = userId;
    request.text = searchString;
    request.pageNumber = pageNumber;
    request.pageSize = pageSize;
    return request;
  };

  RequestFactory.SubscribeDatasetRequest = function (userId, datasetId, datasetLicense) {
    var request = new Request("SubscribeDatasetRequest");
    request.user = userId;
    request.dataset = datasetId;
    request.datasetLicense = datasetLicense;
    return request;
  };

  RequestFactory.UnSubscribeDatasetRequest = function (userId, datasetId, datasetLicense) {
    var request = new Request("UnsubscribeDatasetRequest");
    request.user = userId;
    request.dataset = datasetId;
    request.datasetLicense = datasetLicense;
    return request;
  };

  RequestFactory.PublishDataRequest = function (datasetId) {
    var request = new Request("PublishDataRequest");
    request.datasetId = datasetId;
    return request;
  };

  RequestFactory.PublishData = function (datasetId, dataProfileName, createDatasetEventTypeId, data) {
    var request = new Request("PublishData");
    request.typeId = createDatasetEventTypeId;
    request.context = datasetId;
    request.dataset = datasetId;
    request.typeName = dataProfileName;
    request.isPublishData = true;
    for (var fieldId in data) {
      request[fieldId] = data[fieldId];
    }
    return request;
  };

  RequestFactory.CheckUserDatasetSubscription = function (userId, datasetId) {
    var request = new Request("CheckUserDatasetSubscriptionRequest");
    request.user = userId;
    request.dataset = datasetId;
    return request;
  };

  RequestFactory.GetSubscriptionsRequest = function (userId) {
    var request = new Request("GetDatasetSubscriptionsByUserIdRequest");
    request.user = userId;
    return request;
  };

  RequestFactory.GetAccessAuditInDaysByUserRequest = function (userId, start, end) {
    var request = new Request("GetAccessAuditInDaysByUser");
    request.user = userId;
    request.startTime = parseDate(start);
    request.endTime = parseDate(end);
    return request;
  };

  RequestFactory.GetAccessAuditInMonthsByUserRequest = function (userId, start, end) {
    var request = new Request("GetAccessAuditInMonthsByUser");
    request.user = userId;
    request.startTime = parseDate(start);
    request.endTime = parseDate(end);
    return request;
  };

  //========== ANALYTIC STUDIO ==========
  RequestFactory.CreateAnalyticStudio = function (name, description, createdByOrganization, userId,
                                                  categories, state) {
    var request = new Request("CreateAnalyticStudio");
    request.currentPersistedData = {
      name: name,
      description: description,
      createdByOrganization: createdByOrganization,
      createdByUser: userId,
      categories: categories,
      state: state
    };

    return request;
  };

  RequestFactory.FindAnalyticStudioByNameOrDescriptionRequest = function (searchString, pageNumber, pageSize) {
    var request = new Request("FindAnalyticStudioByNameOrDescriptionRequest");
    request.text = searchString;
    request.pageNumber = pageNumber;
    request.pageSize = pageSize;
    return request;
  };

  RequestFactory.FindAnalyticStudioByIdRequest = function (analyticStudioId) {
    var request = new Request("FindAnalyticStudioByIdRequest");
    request.analyticStudioId = analyticStudioId;
    return request;
  };

  RequestFactory.FindDatasetLicenseRequest = function (dataset) {
    var request = new Request("FindDatasetLicenseRequest");
    request.dataset = dataset;
    return request;
  };

  //========== WIDGET IN SUBSCRIPTION ==========
  RequestFactory.CreateUserDatasetWidget = function (userPersistenceId, datasetId, widgetState) {
    var request = new Request("CreateUserDatasetWidget");
    request.currentPersistedData = {
      user: userPersistenceId,
      dataset: datasetId,
      widgetState: widgetState
    }
    return request;
  };

  RequestFactory.UpdateUserDatasetWidget = function (userPersistenceId, previousPersistedData, currentPersistedData) {
    var request = new Request("UpdateUserDatasetWidget");
    request.previousPersistedData = {
      persistenceId: previousPersistedData.persistenceId,
      dataset: previousPersistedData.dataset,
      widgetState: previousPersistedData.widgetState,
      dataProfile: previousPersistedData.dataProfile,
      user: userPersistenceId
    };

    request.currentPersistedData = {
      persistenceId: currentPersistedData.persistenceId,
      dataset: currentPersistedData.dataset,
      widgetState: currentPersistedData.widgetState,
      dataProfile: currentPersistedData.dataProfile,
      user: userPersistenceId
    };
    return request;
  };

  RequestFactory.FindDatasetWidgetsByUserRequest = function (userPersistenceId, dataset) {
    var request = new Request("FindDatasetWidgetsByUserRequest");
    request.userUUID = userPersistenceId;
    request.dataset = dataset;
    return request;
  };

  RequestFactory.FindDatasetWidgetByProfile = function (dataprofile) {
    var request = new Request("FindDatasetWidgetByProfileRequest");
    request.dataProfile = dataprofile;
    return request;
  };

  RequestFactory.SubscribeRealTimeData = function (datasetId) {
    var request = new Request("SubscribeRealTimeData");
    request.dataset = datasetId;
    return request;
  };

  RequestFactory.StopDataUpdateRequest = function (datasetId) {
    var request = new Request("StopDataUpdateRequest");
    request.dataset = datasetId;
    return request;
  };

  RequestFactory.GetLatestData = function (datasetId, noOfRecords) {
    var request = new Request("GetLatestData");
    request.dataset = datasetId;
    request.noOfRecords = noOfRecords;
    return request;
  };

  RequestFactory.GetDataForTimeRange = function (datasetId, snapshotStartTime, snapshotEndTime, noOfRecords) {
    var request = new Request("GetDataForTimeRange");
    request.dataset = datasetId;
    request.snapshotStartTime = parseDate(snapshotStartTime);
    request.snapshotEndTime = parseDate(snapshotEndTime);
    request.noOfRecords = typeof noOfRecords === "string" ? parseInt(noOfRecords) : noOfRecords;
    return request;
  };

  RequestFactory.GetDataAfterTime = function (datasetId, snapshotStartTime, noOfRecords) {
    var request = new Request("GetDataAfterTime");
    request.dataset = datasetId;
    request.snapshotStartTime = parseDate(snapshotStartTime);
    request.noOfRecords = noOfRecords;
    return request;
  };

  RequestFactory.GetDataBeforeTime = function (datasetId, snapshotEndTime, noOfRecords) {
    var request = new Request("GetDataBeforeTime");
    request.dataset = datasetId;
    request.snapshotEndTime = parseDate(snapshotEndTime);
    request.noOfRecords = noOfRecords;
    return request;
  };

  RequestFactory.GetDataByRecordLocation = function (datasetId, fileBlockIndex, fileBlockRecordIndex,
                                                     getDataByRecordLocationRequestType, noOfRecords) {
    var request = new Request("GetDataByRecordLocation");
    request.dataset = datasetId;
    request.fileBlockIndex = fileBlockIndex;
    request.fileBlockRecordIndex = fileBlockRecordIndex;
    request.requestType = getDataByRecordLocationRequestType;
    request.noOfRecords = noOfRecords;
    return request;
  };

  RequestFactory.TSCalculate = function (datasetId, fieldId, startTime, endTime, timeWindowQuantity, timeWindowUnit,
                                         functionType, repeatTimeQuantity, repeatTimeUnit,
                                         includeRealtimeUpdate = false, businessDayOnly = false, emitEmptyWindow = false) {
    const request = new Request("TSCalculate");
    request.datasetId = datasetId;
    request.fieldId = fieldId;
    request.includeRealtimeUpdate = includeRealtimeUpdate;
    request.businessDayOnly = businessDayOnly;
    request.emitEmptyWindow = emitEmptyWindow;
    request.functionType = parseFunctionType(functionType);

    addWindowedDataRequest(request, startTime, endTime, timeWindowUnit, timeWindowQuantity, repeatTimeUnit, repeatTimeQuantity);
    return request;
  };

  RequestFactory.TSCalculateMinMaxAvgMedian = function (datasetId, fieldId, startTime, endTime, timeWindowQuantity, timeWindowUnit,
                                                        repeatTimeQuantity, repeatTimeUnit, includeRealtimeUpdate = false, businessDayOnly = false, emitEmptyWindow = false) {
    const request = new Request("TSCalculateMinMaxAvgPSquare");
    request.datasetId = datasetId;
    request.fieldId = fieldId;
    request.percentile = 0.5;
    request.includeRealtimeUpdate = includeRealtimeUpdate;
    request.businessDayOnly = businessDayOnly;
    request.emitEmptyWindow = emitEmptyWindow;
    addWindowedDataRequest(request, startTime, endTime, timeWindowUnit, timeWindowQuantity, repeatTimeUnit, repeatTimeQuantity);
    return request;
  };

  RequestFactory.TSCalculateFilterByString = function (datasetId, fieldId, startTime, endTime, timeWindowQuantity, timeWindowUnit,
                                                       functionType, repeatTimeQuantity, repeatTimeUnit,
                                                       stringFilterFieldId, stringFilterValue, stringFilterInversion, stringFilterOperator,
                                                       includeRealtimeUpdate = false, businessDayOnly = false, emitEmptyWindow = false) {
    const request = new Request("TSCalculateFilterByString");
    request.datasetId = datasetId;
    request.fieldId = fieldId;
    request.functionType = parseFunctionType(functionType);
    request.stringFilterFieldId = stringFilterFieldId;
    request.stringFilterValue = stringFilterValue;
    request.stringFilterInversion = stringFilterInversion;
    request.stringFilterOperator = typeof stringFilterOperator === "string" ? parseInt(stringFilterOperator) : stringFilterOperator;
    request.includeRealtimeUpdate = includeRealtimeUpdate;
    request.businessDayOnly = businessDayOnly;
    request.emitEmptyWindow = emitEmptyWindow;
    addWindowedDataRequest(request, startTime, endTime, timeWindowUnit, timeWindowQuantity, repeatTimeUnit, repeatTimeQuantity);

    return request;
  };

  RequestFactory.CanDealGoldReportRequest = function (startDateInfo, endDateInfo, productGroupInfo, orderTypeInfo, dealerInfo) {
    const request = new Request("CanDealGoldReportRequest");
    request.startDateInfo = startDateInfo.replace("Z", "");
    request.endDateInfo = endDateInfo.replace("Z", "");
    request.productGroupInfo = productGroupInfo;
    request.orderTypeInfo = orderTypeInfo;
    request.dealerInfo = dealerInfo;
    return request;
  };


  RequestFactory.GetApiKeys = function (userId) {
    const request = new Request("GetAllApiKeyForCurrentUserRequest");
    request.principal = userId;
    return request;
  };

  RequestFactory.DeleteApiKey = function (apiKey) {
    const request = new Request("DeleteApiKeyRequest");
    request.apiKey = apiKey;
    return request;
  };

  function addWindowedDataRequest(request, startTime, endTime, timeWindowUnit, timeWindowQuantity, repeatTimeUnit, repeatTimeQuantity) {
    if (!endTime) {
      endTime = new Date().toISOString();
    }
    request.startTime = parseDate(startTime);
    request.endTime = parseDate(endTime);
    request.timeWindowUnit = typeof timeWindowUnit === "string" ? parseInt(timeWindowUnit) : timeWindowUnit;
    request.timeWindowQuantity = typeof timeWindowQuantity === "string" ? parseInt(timeWindowQuantity) : timeWindowQuantity;
    request.repeatTimeUnit = typeof repeatTimeUnit === "string" ? parseInt(repeatTimeUnit) : repeatTimeUnit;
    request.repeatTimeQuantity = typeof repeatTimeQuantity === "string" ? parseInt(repeatTimeQuantity) : repeatTimeQuantity;
  }

  function parseFunctionType(value) {
    const stringTypes = ["average", "low", "high", "close", "median"];
    if (typeof value === "number") {
      return value;
    } else {
      const index = stringTypes.indexOf(value.toLowerCase());
      if (index > -1) {
        return index;
      } else {
        return parseInt(value);
      }
    }
  }

  function parseDate(date) {
    // find timezone. ex) 2018-11-17T11:43:13-05:00[America/Toronto]
    const matchs = date.match(/\[(.*?)\]/);
    if (matchs === null) {
      // no timezone found, use local timezone
      const localTimezone = moment.tz.guess();
      return `${moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSZ')}[${localTimezone}]`;
    }
    return date;
  }

  return RequestFactory;
})();

module.exports = RequestFactory;


// WEBPACK FOOTER //
// ./src-client-lib/api/request/gateway-requests.js